import { useState } from 'react';
import './admin.css';
import connector from '../../connector/connector';

const Admin = () => {
const [adminCode, setAdminCode] = useState('');

const authenticateAdmin = async (e) => {
    e.preventDefault();
    // Add authentication logic here
    let response = await connector.authenticateAdminCode(adminCode);
    if(response.authenticated){
        // go to gradebook page
        localStorage.setItem('adminTokenTime', new Date().toISOString());
        window.location.href = '#/admin/dashboard';
    } else{
        alert('Invalid admin code');
    }
}

    return (
        <div className='admin-wrapper'>
           <form onSubmit={authenticateAdmin}>
           <input type="password" placeholder='Enter admin code' value={adminCode} onChange={(e) => {
                setAdminCode(e.target.value);
           }}/>
           </form>
            
        </div>
    );
};

export default Admin;